import { makeStyles } from '@mui/styles';
import React from 'react';
import { useLocation } from 'react-router-dom';

import { BulkSelectCell } from './BulkSelectCell';
import { selectAllHeader } from './BulkSelectHeader';
import SavedSearchesTable from '../../../components/SavedSearchesTable';
import * as Urls from '../../../constants/Urls';
import NavigateLinkCell from '../../../containers/FindPage/NavigateLinkCell';
import { useFormSelector } from '../../../custom-hooks';
import { SAVED_SEARCH_TRAINING_SESSION_SIGNUP_TYPE } from '../../constants/editor.constants';
import { FORM_MODEL_ATTRIBUTES } from '../../constants/form-manager.constants';
import { getEvaluatedExpression, getSsContext } from '../../selectors/form-manager.selectors';
import { getDynamicParamCollectionSelector } from '../../selectors/runtime.selectors';
import { transformFiltersForAPI } from '../../utils/runtime.utils';

const useStyles = makeStyles({
  savedSearchContainer: {
    '& thead > tr > th:nth-child(1) > svg': {
      display: 'none !important',
    },
  },
});

const SSRuntimeSavedSearch = ({
  id,
  index,
  dataObject,
  searchName,
  filter,
  savedSearchType,
  formKey,
}) => {
  const ssContext = useFormSelector(getSsContext, { index, entityName: dataObject });
  const { pathname } = useLocation();
  const classes = useStyles();

  const emptySectionMessage = useFormSelector(getEvaluatedExpression, {
    id,
    index,
    entityName: dataObject,
    prop: FORM_MODEL_ATTRIBUTES.EMPTY_SECTION_MESSAGE,
    defaultValue: null,
  });

  const dynamicParamCollection = useFormSelector(getDynamicParamCollectionSelector, {
    index,
    entityName: dataObject,
    id,
  });

  const isBulkEditPage = pathname === Urls.BULK_EDIT_PAGE;

  const filterConditions =
    filter?.Conditions?.map((condition) => ({ ...condition, Operator: condition.SqlOperator })) ??
    [];

  const customFilter = transformFiltersForAPI(filterConditions, ssContext);

  const extraColumns = [
    {
      index: 0,
      header: selectAllHeader,
      accessor: 'SELECT_ALL_HEADER',
      dataType: 'System.String',
      // eslint-disable-next-line react/display-name
      customCell: ({ row }) => {
        return <BulkSelectCell row={row} formKey={formKey} />;
      },
    },
  ];

  return (
    <div
      className={isBulkEditPage ? classes.savedSearchContainer : null}
      style={{ marginTop: 14 }}
      data-ss-id={id}
    >
      <SavedSearchesTable
        customCell={
          savedSearchType !== SAVED_SEARCH_TRAINING_SESSION_SIGNUP_TYPE &&
          NavigateLinkCell.savedSearchColumnLink
        }
        entityName={dataObject}
        initialSearchName={searchName}
        dataKey={`${id}#${index}`}
        customFilter={customFilter}
        rowsPerPageOptions={[10, 25, 50]}
        enableSorting
        showSearchSelector={false}
        useSearchNameAsTitle
        shouldCompareRevisions={savedSearchType === 'CompareDocumentHistory'}
        showSignUpButton={savedSearchType === SAVED_SEARCH_TRAINING_SESSION_SIGNUP_TYPE}
        emptySectionMessage={emptySectionMessage}
        extraColumns={isBulkEditPage ? extraColumns : []}
        dynamicParamCollection={dynamicParamCollection}
      />
    </div>
  );
};

export default SSRuntimeSavedSearch;
